/* ==============================
 * Tea for Two: Carousel v1.0.0
 * http://teafortwo-project.com
 * ============================ */

+function ($) {
	'use strict';

	// CAROUSEL CLASS DEFINITION
	// =========================

	var TeaForTwoCarousel = function (element, options) {
		this.$window = $(window),
		this.$element = $(element),
		this.$inner = this.$element.find('.teafortwo-carousel-inner'),
		this.$items = this.$inner.children('.item'),
		this.$contollers = this.$element.children('.teafortwo-carousel-control'),
		this.width = this.$window.width(),
		this.breakpoint = options.breakpoint,
		// this.mobile = null,
		this.feed = null;
		// console.log(this.$inner);
		// Fire Constructor
		this.init();
		
	}

	TeaForTwoCarousel.DEFAULTS = {
		breakpoint: 768
	}

	TeaForTwoCarousel.prototype.getWidth = function () {
		return this.$window.width();
	}

	TeaForTwoCarousel.prototype.setFeed = function () {
		var feed;
		if ( this.width < this.breakpoint ) feed = this.width;
		else feed = this.width/2;
		this.feed = feed;
		// console.log('Breakpoint:' + this.breakpoint);
		// console.log(feed);
		return false;
	}

	TeaForTwoCarousel.prototype.setInnerWidth = function () {
		var width = this.feed * this.$items.length;
		this.$inner.width(width);
		return false;
	}

	TeaForTwoCarousel.prototype.hasMore = function (direction, position) {
		if (direction == 'prev' && position == 0) {
			console.log('First');
			return false;	
		}
		else if (direction == 'next' && position == -(this.feed*this.$items.length - this.width)) {
			console.log('Last');
			return false
		}
		else return true;
	}

	TeaForTwoCarousel.prototype.slide = function (e) {
		e.preventDefault();

		var $contoller = $(this),
				that = e.data.carousel,
				$inner = that.$inner;
		var direction = $contoller.data('slide'),
				position = $inner.position().left;

		// Check if there is more item on the directioin
		if ( !that.hasMore(direction, position) ) return false;

		if (direction == 'prev') { // To Left
			$inner.css('left', position + that.feed);
		} else { // To Right
			$inner.css('left', position - that.feed);
		}

		return null
	}

	TeaForTwoCarousel.prototype.resize = function (e) {

		var that = e.data.carousel;

		that.width = that.getWidth;
		that.setFeed();
		that.setInnerWidth();
 		
 		return false;
	}

	TeaForTwoCarousel.prototype.setEventHandler = function () {
		this.$contollers.on('click', {carousel: this}, this.slide);
		// this.$window.on('resize', {carousel: this}, this.resize);
	}

	TeaForTwoCarousel.prototype.init = function () {
		this.setFeed();
		this.setInnerWidth();
		this.setEventHandler();
	}

	$.fn.tftCarousel = function (option) {
		var $this = $(this),
				data = $this.data('tft.carousel'),
				options = $.extend({}, TeaForTwoCarousel.DEFAULTS, $this.data(), typeof option == 'object' && option);
		
		if (!data)
			$this.data(
				'tft.carousel',
				(data = new TeaForTwoCarousel(this, options))
			);
	}
}(jQuery);